<template>
	<div class="ReServiceCharts mb-5">
		<div class="col-sm-12 col-md-10 priceChart px-0">
		<span v-if="TheData ==''" class="text-center">Нет данных статистики</span>
		<div class="card-chart" v-if="TheData !=''">
			<h4 >Статистика</h4>
			
			<div class="chart-area" >
				<bar-chart
				:labels="OlapChart.chartData.labels"
				:chart-data="chartData"
				:chart-options="OlapChart.chartOptions"
				:extra-options="OlapChart.extraOptions"
				:plugins="OlapChart.plugins"
				:height="150"
				
				>
				</bar-chart>

			</div>
		</div>

		</div>


	</div>
</template>

<script>
	import BarChart from 'src/components/Charts/BarChart';
	import moment from 'moment';
	import VueMoment from 'vue-moment';
	import config from '@/config';
	import * as chartConfigs from '@/components/Charts/config';
	import { Tooltip, Button } from 'element-ui';
	import Plural from 'src/mixins/Plural.js';
	import swal from 'sweetalert2';

/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
	export default {
		name: 'ReServiceCharts',
		mixins: [Plural],
		components: {
			BarChart,
			[Tooltip.name]: Tooltip,
			[Button.name]: Button,


		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			TheData: [Object, String, Array], // ибо задолбало, что в разных площадках могут придти все эти типы
			GroupAds: [Boolean],
			useDate: [Boolean],
			groupTime: String,
		},
		data () {
			return {
				chartData: {},
				ver: 1,
				colors: ["#01B0E099", "#00BF9A99", "#F84E5499", "#FF8D7299", "#9E77F399","#e0a50199"],
			}
			
		},

		computed: {
			OlapChart(){
				let OlapChart = {
					plugins: {
						datalabels: {
							color: 'white',
							font: {
								weight: 'bold'
							}
						}
					},
					chartData: {
						labels: [
						
						],
						datasets: [
							{
								label: 'Количество обращений',
								fill: true,
								borderWidth: 0,
								data: [],
								hoverBorderWidth: 6,
								backgroundColor: config.colors.primary,
								hoverBackgroundColor: config.colors.primary,
								borderColor: config.colors.primary,
							},
						]
					},
					//extraOptions: chartConfigs.barChartOptionsGradient,
					extraOptions:{
						maintainAspectRatio: true,
						responsive: true,
						interaction: {
							intersect: false,
						},
						legend: {
							display: true,
							align: 'start',
							position: 'bottom',
							labels: {
								fontColor: '#9499a7',
								fontSize: 16,
								borderRadius: '6px', //кажется не работает Border radius of the legend box
							},
						},
						scales: {
							xAxes: [{
								type:'category',// 'time',
								time:{
									unit: 'month',
								},
								displayFormats: {
									'day':'Do.MM.YYYY ddd',
									'month':'Do.MM.YYYY ddd',
								},
								tooltipFormat: 'DD MMMM YYYY dddd',
								gridLines: {
									drawBorder: true,
									color: 'rgba(253,93,147,0.2)',
									zeroLineColor: 'rgba(0,191,154,0.4)' //'transparent'
								},
								ticks: {
									padding: 5,
									fontSize: 13, //кажется это не вполне адаптивно, надо проверить, когда будет 30 дней данных. если убрать параметр, то оно само работает
									fontColor: '#9499a7',
									autoSkip: true,
        							autoSkipPadding: 50
								},
								beginAtZero: true
							}],
							yAxes: [{
								gridLines: {
									drawBorder: false,
									color: 'rgba(253,93,147,0.2)',
									zeroLineColor: 'rgba(0,191,154,0.4)' //'transparent'
								},
								ticks: {
									padding: 10,
									fontSize: 13,
									fontColor: '#9499a7',
									beginAtZero: true
								}
							}]
						},	
					},
					
				};
				OlapChart.chartData.labels = [];
				// this.OlapChart.chartData.datasets[0].data = [];
				OlapChart.chartData.datasets = [];
				// this.OlapChart.chartData.datasets[1].data = [];
				// this.OlapChart.chartData.datasets[2].data = [];
				// Object.keys(this.TheData).forEach((key)=>{
				// 	let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
				// 	if(strDate == "Invalid date") strDate = '';
				// 	this.OlapChart.chartData.labels.push(key);
				// 	this.OlapChart.chartData.datasets[0].data.push(this.TheData[key]);	
				// 	// this.OlapChart.chartData.datasets[0].label.push(key);	
				// 	// this.OlapChart.chartData.datasets[1].data.push(this.TheData[key].favorites);	
				// 	// this.OlapChart.chartData.datasets[2].data.push(this.TheData[key].phones);						
									
				// });

				// console.log('this.TheData',Object.values(this.TheData),this.GroupAds);

				let dateArray = [];
				let dateLables = [];
				const month = [];
				const daysInMonth = (year, month) => new Date(year, month, 0).getDate();
				// month = this.newDate(daysInMonth);
				// console.log('month',month);
				// for (let i = 0; i < daysInMonth; ++i) {
				// 	this.OlapChart.chartData.labels.push(this.newDate(i));
				// }
				Object.values(this.TheData).forEach(ads=>{
					ads.forEach(row=>{
						if(dateArray.indexOf(row.date)==-1)
						dateArray.push(row.date);
					})
				})
				dateArray.sort();
				// console.log(dateArray);

				OlapChart.extraOptions.scales.xAxes[0].type = !this.useDate? 'time' : 'category';
				OlapChart.extraOptions.scales.xAxes[0].time = {
					unit: this.groupTime,
					// round: this.groupTime,
				};

				// console.log(this.OlapChart.extraOptions.scales.xAxes[0]);
				if(this.GroupAds){
					for (const [key, value] of Object.entries(this.TheData)) {
						// console.log(`${key}: ${value}`);
						// console.log(value);
						let datacounts = new Array(dateArray.length).fill(0);
						value.forEach((item)=>{
							// dateLables.push(item.date);
							datacounts[dateArray.indexOf(item.date)] = item.count;
						});

						// this.OlapChart.chartData.labels.push(key);

						OlapChart.chartData.datasets.push({
							label: key,
							fill: true,
							borderWidth: 0,
							data: datacounts,
							hoverBorderWidth: 6,
							backgroundColor: this.colors[OlapChart.chartData.datasets.length],
							hoverBackgroundColor: config.colors.primary,
							borderColor: config.colors.primary,
						});

						
					}
					// this.OlapChart.extraOptions.legend.display = true;

				}else{
					let datacounts = new Array(dateArray.length).fill(0);
					for (const [key, value] of Object.entries(this.TheData)) {
						// console.log(`${key}: ${value}`);
						// console.log(value);
						value.forEach((item)=>{
							// dateLables.push(item.date);
							datacounts[dateArray.indexOf(item.date)] += item.count;
						});

					}					
					OlapChart.chartData.datasets.push({
							label: 'Обращений',
							fill: true,
							borderWidth: 0,
							data: datacounts,
							hoverBorderWidth: 6,
							backgroundColor: this.colors[0],
							hoverBackgroundColor: config.colors.primary,
							borderColor: config.colors.primary,
						});
					// this.OlapChart.extraOptions.legend.display = false;

				}
				dateLables = [...new Set(dateArray)];
				dateLables.forEach((item)=>{
					OlapChart.chartData.labels.push(item);
					// this.OlapChart.chartData.datasets[key].data.push(this.TheData[key].);	
				});
				this.$set(this,'chartData', Object.assign({},OlapChart.chartData));				
				return OlapChart;
			},
			/*
			strSetChartData(){

				this.OlapChart.chartData.labels = [];
				// this.OlapChart.chartData.datasets[0].data = [];
				this.OlapChart.chartData.datasets = [];
				// this.OlapChart.chartData.datasets[1].data = [];
				// this.OlapChart.chartData.datasets[2].data = [];
				// Object.keys(this.TheData).forEach((key)=>{
				// 	let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
				// 	if(strDate == "Invalid date") strDate = '';
				// 	this.OlapChart.chartData.labels.push(key);
				// 	this.OlapChart.chartData.datasets[0].data.push(this.TheData[key]);	
				// 	// this.OlapChart.chartData.datasets[0].label.push(key);	
				// 	// this.OlapChart.chartData.datasets[1].data.push(this.TheData[key].favorites);	
				// 	// this.OlapChart.chartData.datasets[2].data.push(this.TheData[key].phones);						
									
				// });

				// console.log('this.TheData',Object.values(this.TheData),this.GroupAds);

				let dateArray = [];
				let dateLables = [];
				const month = [];
				const daysInMonth = (year, month) => new Date(year, month, 0).getDate();
				// month = this.newDate(daysInMonth);
				// console.log('month',month);
				// for (let i = 0; i < daysInMonth; ++i) {
				// 	this.OlapChart.chartData.labels.push(this.newDate(i));
				// }
				Object.values(this.TheData).forEach(ads=>{
					ads.forEach(row=>{
						if(dateArray.indexOf(row.date)==-1)
						dateArray.push(row.date);
					})
				})
				dateArray.sort();
				// console.log(dateArray);

				this.OlapChart.extraOptions.scales.xAxes[0].type = !this.useDate? 'time' : 'category';
				this.OlapChart.extraOptions.scales.xAxes[0].time = {
					unit: this.groupTime,
					// round: this.groupTime,
				};

				// console.log(this.OlapChart.extraOptions.scales.xAxes[0]);
				if(this.GroupAds){
					for (const [key, value] of Object.entries(this.TheData)) {
						// console.log(`${key}: ${value}`);
						// console.log(value);
						let datacounts = new Array(dateArray.length).fill(0);
						value.forEach((item)=>{
							// dateLables.push(item.date);
							datacounts[dateArray.indexOf(item.date)] = item.count;
						});

						// this.OlapChart.chartData.labels.push(key);

						this.OlapChart.chartData.datasets.push({
							label: key,
							fill: true,
							borderWidth: 0,
							data: datacounts,
							hoverBorderWidth: 6,
							backgroundColor: this.colors[this.OlapChart.chartData.datasets.length],
							hoverBackgroundColor: config.colors.primary,
							borderColor: config.colors.primary,
						});

						
					}
					// this.OlapChart.extraOptions.legend.display = true;

				}else{
					let datacounts = new Array(dateArray.length).fill(0);
					for (const [key, value] of Object.entries(this.TheData)) {
						// console.log(`${key}: ${value}`);
						// console.log(value);
						value.forEach((item)=>{
							// dateLables.push(item.date);
							datacounts[dateArray.indexOf(item.date)] += item.count;
						});

					}					
					this.OlapChart.chartData.datasets.push({
							label: 'Обращений',
							fill: true,
							borderWidth: 0,
							data: datacounts,
							hoverBorderWidth: 6,
							backgroundColor: this.colors[0],
							hoverBackgroundColor: config.colors.primary,
							borderColor: config.colors.primary,
						});
					// this.OlapChart.extraOptions.legend.display = false;

				}
				dateLables = [...new Set(dateArray)];
				dateLables.forEach((item)=>{
					this.OlapChart.chartData.labels.push(item);
					// this.OlapChart.chartData.datasets[key].data.push(this.TheData[key].);	
				});
				this.$set(this,'chartData', Object.assign({},this.OlapChart.chartData));
				// console.log(this.OlapChart);
				// datacounts.forEach((item)=>{
				// 	this.OlapChart.chartData.labels.push(item);
				// });

				// this.OlapChart.chartData.datasets.forEach((item)=>{
				// 	if(item.contains())
				// });
				
				
				// Object.keys(this.TheData).forEach((key)=>{
				// 	let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
				// 	if(strDate == "Invalid date") strDate = '';
					
				// 	// this.OlapChart.chartData.labels.push(key);
				// 	// this.OlapChart.chartData.datasets[0].data.push(this.TheData[key]);	
				// 	// this.OlapChart.chartData.datasets[0].label.push(key);	
				// 	// this.OlapChart.chartData.datasets[1].data.push(this.TheData[key].favorites);	
				// 	// this.OlapChart.chartData.datasets[2].data.push(this.TheData[key].phones);	
					

				// 	this.OlapChart.chartData.datasets.push({
				// 		label: key,
				// 		fill: true,
				// 		borderWidth: 0,
				// 		data: this.TheData[key],
				// 		hoverBorderWidth: 6,
				// 		backgroundColor: config.colors.primary,
				// 		hoverBackgroundColor: config.colors.primary,
				// 		borderColor: config.colors.primary,
				// 	});
									
				// });

				// for(let i = 0; this.TheData.length < 0; i++){
				// 	let strDate = moment(this.TheData[i].date).format("DD.MM.YY");
				// 	if(strDate == "Invalid date") strDate = '';
				// 	this.OlapChart.chartData.labels.push(strDate);
				// 	this.OlapChart.chartData.datasets[0].data.push(this.TheData[i].count);	
				// }
				return '';
			},
			*/
		},
		watch:{
			/*
			GroupAds(){
				this.strSetChartData();
			},
			useDate(){
				this.strSetChartData();
			},
			groupTime(){
				this.strSetChartData();
			},
			*/
		},
		methods: {
			strSetChartData(){
				return ; // Перенес в computed
				this.OlapChart.chartData.labels = [];
				// this.OlapChart.chartData.datasets[0].data = [];
				this.OlapChart.chartData.datasets = [];
				// this.OlapChart.chartData.datasets[1].data = [];
				// this.OlapChart.chartData.datasets[2].data = [];
				// Object.keys(this.TheData).forEach((key)=>{
				// 	let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
				// 	if(strDate == "Invalid date") strDate = '';
				// 	this.OlapChart.chartData.labels.push(key);
				// 	this.OlapChart.chartData.datasets[0].data.push(this.TheData[key]);	
				// 	// this.OlapChart.chartData.datasets[0].label.push(key);	
				// 	// this.OlapChart.chartData.datasets[1].data.push(this.TheData[key].favorites);	
				// 	// this.OlapChart.chartData.datasets[2].data.push(this.TheData[key].phones);						
									
				// });

				// console.log('this.TheData',Object.values(this.TheData),this.GroupAds);

				let dateArray = [];
				let dateLables = [];
				const month = [];
				const daysInMonth = (year, month) => new Date(year, month, 0).getDate();
				// month = this.newDate(daysInMonth);
				// console.log('month',month);
				// for (let i = 0; i < daysInMonth; ++i) {
				// 	this.OlapChart.chartData.labels.push(this.newDate(i));
				// }
				Object.values(this.TheData).forEach(ads=>{
					ads.forEach(row=>{
						if(dateArray.indexOf(row.date)==-1)
						dateArray.push(row.date);
					})
				})
				dateArray.sort();
				// console.log(dateArray);

				this.OlapChart.extraOptions.scales.xAxes[0].type = !this.useDate? 'time' : 'category';
				this.OlapChart.extraOptions.scales.xAxes[0].time = {
					unit: this.groupTime,
					// round: this.groupTime,
				};

				// console.log(this.OlapChart.extraOptions.scales.xAxes[0]);
				if(this.GroupAds){
					for (const [key, value] of Object.entries(this.TheData)) {
						// console.log(`${key}: ${value}`);
						// console.log(value);
						let datacounts = new Array(dateArray.length).fill(0);
						value.forEach((item)=>{
							// dateLables.push(item.date);
							datacounts[dateArray.indexOf(item.date)] = item.count;
						});

						// this.OlapChart.chartData.labels.push(key);

						this.OlapChart.chartData.datasets.push({
							label: key,
							fill: true,
							borderWidth: 0,
							data: datacounts,
							hoverBorderWidth: 6,
							backgroundColor: this.colors[this.OlapChart.chartData.datasets.length],
							hoverBackgroundColor: config.colors.primary,
							borderColor: config.colors.primary,
						});

						
					}
					// this.OlapChart.extraOptions.legend.display = true;

				}else{
					let datacounts = new Array(dateArray.length).fill(0);
					for (const [key, value] of Object.entries(this.TheData)) {
						// console.log(`${key}: ${value}`);
						// console.log(value);
						value.forEach((item)=>{
							// dateLables.push(item.date);
							datacounts[dateArray.indexOf(item.date)] += item.count;
						});

					}					
					this.OlapChart.chartData.datasets.push({
							label: 'Обращений',
							fill: true,
							borderWidth: 0,
							data: datacounts,
							hoverBorderWidth: 6,
							backgroundColor: this.colors[0],
							hoverBackgroundColor: config.colors.primary,
							borderColor: config.colors.primary,
						});
					// this.OlapChart.extraOptions.legend.display = false;

				}
				dateLables = [...new Set(dateArray)];
				dateLables.forEach((item)=>{
					this.OlapChart.chartData.labels.push(item);
					// this.OlapChart.chartData.datasets[key].data.push(this.TheData[key].);	
				});
				this.$set(this,'chartData', Object.assign({},this.OlapChart.chartData));
				// console.log(this.OlapChart);
				// datacounts.forEach((item)=>{
				// 	this.OlapChart.chartData.labels.push(item);
				// });

				// this.OlapChart.chartData.datasets.forEach((item)=>{
				// 	if(item.contains())
				// });


				// Object.keys(this.TheData).forEach((key)=>{
				// 	let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
				// 	if(strDate == "Invalid date") strDate = '';
					
				// 	// this.OlapChart.chartData.labels.push(key);
				// 	// this.OlapChart.chartData.datasets[0].data.push(this.TheData[key]);	
				// 	// this.OlapChart.chartData.datasets[0].label.push(key);	
				// 	// this.OlapChart.chartData.datasets[1].data.push(this.TheData[key].favorites);	
				// 	// this.OlapChart.chartData.datasets[2].data.push(this.TheData[key].phones);	
					

				// 	this.OlapChart.chartData.datasets.push({
				// 		label: key,
				// 		fill: true,
				// 		borderWidth: 0,
				// 		data: this.TheData[key],
				// 		hoverBorderWidth: 6,
				// 		backgroundColor: config.colors.primary,
				// 		hoverBackgroundColor: config.colors.primary,
				// 		borderColor: config.colors.primary,
				// 	});
									
				// });

				// for(let i = 0; this.TheData.length < 0; i++){
				// 	let strDate = moment(this.TheData[i].date).format("DD.MM.YY");
				// 	if(strDate == "Invalid date") strDate = '';
				// 	this.OlapChart.chartData.labels.push(strDate);
				// 	this.OlapChart.chartData.datasets[0].data.push(this.TheData[i].count);	
				// }
				return '';
			},
			setChartData(){
				// пока эту ф-ю не использую, потому что считаю в компьютед
				
				this.OlapChart.chartData.labels = [];
				this.OlapChart.chartData.datasets[0].data = [];
				
				
				Object.keys(this.TheData).forEach((key)=>{
					let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
					if(strDate == "Invalid date") strDate = '';
					this.OlapChart.chartData.labels.push(strDate);
					this.OlapChart.chartData.datasets[0].data.push(this.TheData[key].views);
					// console.log('this.TheData', key);
				});
				
			},
			// newDate(days) {

			// 	return DateTime.now().plus({days}).toJSDate();
			// },
			// getRandomColor() {
			// 	let colorArr = [];
			// 	for (let i = 0; i < 50; i++) {
			// 		let letters = '0123456789ABCDEF'.split('');
			// 		let color = '#';
			// 		for (let j = 0; j < 6; j++ ) {
			// 			color += letters[Math.floor(Math.random() * 16)];
			// 		}
			// 		colorArr.push(color);
			// 		// console.log(color);
			// 	}
			// 	return colorArr;
			// }
			
		},
		mounted() {
			// console.log('config.barChartOptionsGradient',config.barChartOptionsGradient);
			
		}
	}
</script>
<style scoped>

/* .ReServiceCharts {border: 1px solid #01b0e0; padding: 20px; border-radius: 6px;} */
.ReServiceCharts-warning {border: 1px dashed #F84E54; padding: 20px 5px 0px 15px; border-radius: 6px; }
.ReServiceCharts-warning, .warning-msg {display: flex; flex-direction: column; align-items: center;}
.ReServiceCharts .badge {line-height: inherit;}
.ReServiceCharts-form {display: flex; flex-direction: row; align-items: flex-start;}
.auction, .ReServiceCharts-plan {    
	margin: 15px 0px;
    border-radius: 6px;
    padding: 10px;
}
.auction {border: 1px dashed #BA54F5;}
.ReServiceCharts-plan {border: 1px dashed #01B0E0; }
.ReServiceCharts-form .btn-position {margin-top: 32px;}

.ReMarketingSitesOnObj {border: 1px dashed #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;}
.notEnoughMoney {display: flex; flex-direction: column;}
.notEnoughMoney p, .notEnoughMoney a {text-align: center;}
/* .ReServiceCharts >>> .notEnoughMoney p {color: #1d253b!important;} */
.ReServiceCharts >>> .bootstrap-switch{width: 70px !important; margin: 0;}
.ReServiceCharts >>> .bootstrap-switch .bootstrap-switch-label{left: 55%;}
.ReServiceCharts >>> .bootstrap-switch-container{width: 106px !important;}
.ReServiceCharts >>> .bootstrap-switch .bootstrap-switch-handle-off {text-indent: 6px; padding-right: 6px!important;}
.ReServiceCharts >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReServiceCharts >>> .tab-label > span{display: inline-flex!important;}
.ReServiceCharts >>> .siteblock {display: flex; flex-wrap: wrap;}
.ReServiceCharts >>> .el-table table th:nth-last-child(2)  {text-align: right;}

/* .ReServiceCharts >>> .row-expand-hover:hover {cursor:pointer;} */
.ReServiceCharts >>> .row-expand-cover .el-table__expand-icon{visibility:hidden;}
.ReServiceCharts >>> .el-table__expand-icon {
    color: #00BF9A !important;
	font-size: 14px;
}

/*===chart===============================*/
.priceChart {display: flex; flex-direction: column;}
.ReServiceCharts >>> .card-chart {border: 1px solid #01b0e0; border-radius: 6px; padding: 10px;}
/* .ReMediaCharts >>> .card-chart h4 {margin-bottom: 10px;} */
.ReServiceCharts >>> .card-chart .chart-area {height: auto;}

@media (max-width: 825px){
	.ReServiceCharts-form .btn-position {margin-top: 10px;}	
	
}
@media (max-width: 768px){
	.ReServiceCharts >>> .siteblock {flex-direction: column;}
	.ReServiceCharts >>> .el-table .cell {padding: 0px;}
	.ReServiceCharts >>> .ReActionBtns {justify-content: flex-start;}
	.ReServiceCharts >>> .nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
		margin-bottom: 15px;
	}
	.ReServiceCharts {padding: 15px; min-width: 700px;}
	.ReServiceCharts >>> .el-table table th:nth-last-child(2) {text-align: left;}
}
@media (max-width: 525px){
	.ReServiceCharts >>> .nav-pills .nav-item .nav-link {padding: 5px 20px;}
}

</style>
